import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import {
  REDUX_ACTION_PREFIX,
  REDUX_OPTION
} from 'modules/redux/constants'
import loadReduxAction from 'modules/redux/actions/load'
import {
  SQUAD_DOMAIN,
  SQUAD_ENDPOINT,
  SQUAD_KEY,
  SQUAD_PATH,
  SQUAD_PRODUCTS_QUERY_PARAMS
} from 'modules/squad/redux/constants'
import joinPathsStrUtil from 'utils/string/join-paths'
import mergeMemberProductsUtil from 'modules/squad/redux/actions/load-member-products-by-filter-type/utils/merge'

export default function loadMemberProductsByFilterTypeSquadAction (props) {
  return async (dispatch) => {
    const logLabel = 'loadMemberProductsByFilterTypeSquadAction'
    logUtil(logLabel).debug('[start] props=', props)

    const key = SQUAD_KEY.MEMBER_ID_TO_FILTER_TYPE_PRODUCTS
    const action = getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.LOAD,
      SQUAD_DOMAIN,
      key
    )

    const { memberId, filterType } = props
    const path = joinPathsStrUtil(
      SQUAD_PATH[key],
      memberId,
      filterType
    )

    const query = {
      [SQUAD_PRODUCTS_QUERY_PARAMS.SKIP_COUNT]: props.skipCount,
      [SQUAD_PRODUCTS_QUERY_PARAMS.PAGE_SIZE]: props.pageSize,
      [SQUAD_PRODUCTS_QUERY_PARAMS.FILTER_TYPE]: filterType,
      [SQUAD_PRODUCTS_QUERY_PARAMS.TARGET_CUSTOMER_ID]: memberId
    }

    const endpoint = SQUAD_ENDPOINT.MEMBER_PRODUCTS
    await dispatch(
      loadReduxAction({
        action,
        path,
        logLabel,
        endpoint,
        query,
        options: {
          [REDUX_OPTION.NEEDS_AUTHENTICATION]: true,
          [REDUX_OPTION.MERGE_FUNCTION]: mergeMemberProductsUtil
        }
      })
    )
  }
}
